import React from 'react';
import PropTypes from 'prop-types'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import { Navbar, Nav } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import UserDropdownMenu from './user-dropdown-menu'
import LeftMenu from './left-menu'
import SealBlack from './seal-black.png'

const Header = () => {
  
    return (
        <React.Fragment>
            <Navbar expand='xl' bg='primary' variant='dark' fixed="top" collapseOnSelect>
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                <Navbar.Collapse id='basic-navbar-nav'>
                    <LeftMenu />
                    <Nav className='ml-auto'>
                        <UserDropdownMenu />
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </React.Fragment>
    )
}

Header.propTypes = {
    name: PropTypes.string,
    onLogout: PropTypes.func
}

Header.defaultProps = {
    onLogout: () => {}
}

export default Header
